import { Label } from '@atlaskit/form';
import { token } from '@atlaskit/tokens';
import classNames from 'classnames';
import React, { type FunctionComponent, type ReactNode } from 'react';
import styled from 'styled-components';

import { ErrorMessage, HelperMessage, RequiredAsterisk } from './FormComponents';

const FieldWrapper = styled.div<{ isCreatableFieldSettingContainer?: boolean }>`
  & + * {
    margin-top: ${token('space.300')};
  }

  ${(props) => (props.isCreatableFieldSettingContainer ? 'display: flex' : '')}
`;

export interface FieldDecoratorProps {
  label?: string;
  labelId?: string;
  showRequiredIndicator?: boolean;
  description?: string | ReactNode;
  children: ReactNode;
  isCompact?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  isCreatableFieldSettingContainer?: boolean;
}

/**
 * Renders a label above its children and a description or error message below.
 */
const FieldDecorator: FunctionComponent<FieldDecoratorProps> = ({
  label,
  labelId,
  showRequiredIndicator,
  description,
  children,
  isCompact,
  hasError,
  errorMessage,
  isCreatableFieldSettingContainer,
}) => {
  return (
    <FieldWrapper
      className={classNames({ isCompact })}
      isCreatableFieldSettingContainer={isCreatableFieldSettingContainer}
    >
      {label && (
        <Label htmlFor={label} id={labelId}>
          {label}
          {showRequiredIndicator && <RequiredAsterisk />}
        </Label>
      )}
      {children}
      {description && !hasError && <HelperMessage>{description}</HelperMessage>}
      {errorMessage && hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </FieldWrapper>
  );
};

export default FieldDecorator;
